/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import CustomModal from '../../../components/Modal/CustomModal';
import { InviteExternalUserModalApp } from '../Functionality/InviteExternalUserModalApp';
import { MY_APARTMENT_INVITATION_STEPS } from '../Model/Model';
import InviteExternalUserStep1 from './InviteExternalUserSteps/InviteExternalUserStep1';
import InviteExternalUserStep2 from './InviteExternalUserSteps/InviteExternalUserStep2';
import InviteExternalUserStep3 from './InviteExternalUserSteps/InviteExternalUserStep3';

/**
 * Wizard the logged resident fills to invite an external user, it walks the type
 * of visitor -with the chip search of the visitors already registered-, the contact
 * of the visitor and the schedule of the visit. It is opened from the invite
 * button next to the tabs of the building detail.
 *
 * @param {Object} props
 * @param {boolean} props.show - Renders the modal.
 * @param {Function} props.onHide - Closes the modal.
 * @param {Object} props.buildingDetail - Building of the logged resident, the invitation is created on it.
 * @param {Function} props.setModified - Reloads the invitations of the tab once the invitation is created.
 */
const InviteExternalUserModal = ({ show, onHide, buildingDetail, setModified }) => {
    const {
        t,
        activeStep,
        isLastStep,
        progress,
        emptyFields,
        visitorType,
        visitorTypes,
        isVisitorTypeLocked,
        invitation,
        visitors,
        selectedVisitors,
        handleSelectVisitors,
        handleSelectVisitorType,
        handleChange,
        handleClose,
        handleBack,
        handleContinue
    } = InviteExternalUserModalApp({ show, onHide, buildingDetail, setModified });

    return (
        <CustomModal
            title={'invite_external_user'}
            show={show}
            size={'lg'}
            showProgress={true}
            progress={progress}
            buttonConfirm={isLastStep ? 'confirm' : 'continue'}
            buttonCancelText={activeStep === MY_APARTMENT_INVITATION_STEPS.VISITOR_TYPE ? 'cancel' : 'back'}
            cancelButton={true}
            confirmButton={true}
            disabled={activeStep === MY_APARTMENT_INVITATION_STEPS.VISITOR_TYPE && !visitorType}
            onConfirm={handleContinue}
            onHide={handleBack}
            onClose={handleClose}
            classNameBody={'pt-2'}
        >
            { activeStep === MY_APARTMENT_INVITATION_STEPS.VISITOR_TYPE &&
                <InviteExternalUserStep1
                    t={t}
                    visitorType={visitorType}
                    visitorTypes={visitorTypes}
                    disabled={isVisitorTypeLocked}
                    handleSelectVisitorType={handleSelectVisitorType}
                    visitors={visitors}
                    selectedVisitors={selectedVisitors}
                    handleSelectVisitors={handleSelectVisitors}
                />
            }

            { activeStep === MY_APARTMENT_INVITATION_STEPS.VISITOR_DATA &&
                <InviteExternalUserStep2
                    t={t}
                    emptyFields={emptyFields}
                    invitation={invitation}
                    handleChange={handleChange}
                />
            }

            { activeStep === MY_APARTMENT_INVITATION_STEPS.SCHEDULE &&
                <InviteExternalUserStep3
                    t={t}
                    emptyFields={emptyFields}
                    invitation={invitation}
                    handleChange={handleChange}
                />
            }
        </CustomModal>
    );
};

export default InviteExternalUserModal;
